import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tenant-information',
  templateUrl: './tenant-information.component.html',
  styleUrls: ['./tenant-information.component.scss']
})
export class TenantInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
